import React from 'react';

const AccountIcon = () => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 20 20">
    <path d="M8.5,16.2c-0.5-0.9-1.1-1.8-1.6-2.7c0.2,0,0.4,0,0.6-0.1c0.7-0.1,1.4-0.1,2-0.2c0.1,0,0.1-0.1,0.2-0.1
c0.5-0.7,1.1-1.3,1.6-2c0.5-0.6,1.1-1.1,1.8-1.6c0,0,0.1-0.1,0.1-0.1c-0.2-0.1-0.3-0.1-0.4-0.2c-0.3-0.1-0.6-0.1-0.9-0.1
c-0.1,0-0.2,0-0.3,0c0,0-0.1-0.1-0.2-0.1l0,0c-0.1,0-0.2-0.1-0.3-0.1c0,0,0-0.1-0.1-0.1c-0.1,0-0.2,0-0.2-0.2c-0.1,0-0.1,0-0.2,0
c0,0,0-0.1,0-0.2c-0.1,0-0.2,0.1-0.3,0.1c0-0.1,0-0.2,0-0.2c0,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1s0,0,0-0.1
c-0.1,0-0.2,0.1-0.4,0.2c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0-0.2,0-0.2-0.2C9.2,8,9.1,8.1,9,8.1
c0,0-0.1,0-0.2,0l0,0c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.2,0c-0.1,0-0.2,0.1-0.2,0.2
c0,0,0-0.1-0.1-0.1C7.7,8.2,7.6,8.3,7.5,8.4c0,0,0-0.1-0.1-0.1C7.3,8.3,7.3,8.4,7.1,8.4c0,0,0-0.1-0.1-0.1C7,8.4,6.9,8.5,6.8,8.7
c0-0.1,0-0.2,0-0.2C6.6,8.6,6.5,8.7,6.3,8.8c0-0.1,0-0.2,0-0.2C6.2,8.7,6.1,8.8,5.9,8.9c0-0.1,0-0.1,0-0.2C5.7,8.9,5.6,9,5.5,9.1h0
c0,0,0-0.1,0-0.2C5.4,9.1,5.3,9.2,5.1,9.3c0-0.1,0-0.1,0-0.2C5,9.3,4.8,9.4,4.7,9.6h0c0,0,0-0.1,0-0.1C4.5,9.6,4.4,9.7,4.2,9.8
c0-0.1,0-0.1,0-0.2C3.9,10,3.5,10.2,3,10.1c0.1-0.1,0.1-0.1,0.1-0.1C3.7,9.6,4.3,9,4.7,8.4c0-0.1,0.1-0.2,0.1-0.3
C4.6,8.1,4.5,8.2,4.3,8.3c0,0,0-0.1,0-0.1C4.1,8.2,4,8.3,3.9,8.4c-0.1,0-0.2,0-0.2,0s-0.1,0-0.1,0c-0.2,0-0.3,0.1-0.4,0.1
C3,8.5,2.8,8.6,2.6,8.6c-0.1,0-0.2,0.1-0.3-0.1C1.8,8.8,1.8,8.8,1.7,8.7C1.5,8.8,1.4,8.8,1.2,8.9C1.1,8.9,1,8.9,1,8.8
C0.7,8.9,0.5,9,0.2,8.9c0,0-0.1,0-0.2-0.1v0c0,0,0.1,0,0.2,0c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.5-0.7,0.8-1.1
c0.6-0.9,1.4-1.4,2.3-1.9c0.7-0.3,1.4-0.6,2.1-0.8C6.7,4,6.9,4,7,4c0.5,0,1,0.1,1.4,0.2c0,0,0.1,0,0.2,0c1.6-0.7,3-0.5,4.3,0.6
c0.5,0.5,1,1.1,1.4,1.6c0.4,0.4,0.7,0.8,1,1.2c0.1,0.1,0.3,0.2,0.4,0.4c0,0,0.2,0,0.2,0c0.6-0.2,1.2-0.4,1.9-0.6
c0.5-0.1,0.9-0.2,1.4-0.3c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0,0,0.1,0,0.2c-0.3,0.4-0.6,0.8-0.9,1.2
c-1.4,1.6-3,2.8-5,3.6c-1.1,0.4-2.1,0.8-3.2,1c-0.3,0.1-0.7,0.1-1,0.2c-0.1,0-0.1,0-0.2,0.1c-0.4,0.8-0.8,1.6-1.2,2.3
C8.6,16.1,8.5,16.2,8.5,16.2z M17.9,8.3c0.2,0,0.2-0.1,0.2-0.2c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.2
C17.6,8.2,17.7,8.3,17.9,8.3z"
    />
  </svg>
);

export default AccountIcon;
